<template>
  <div class="py-2 text-center">
    <v-img
      class="mx-auto"
      contain
      :max-height="$vuetify.application.top - 15"
      max-width="60%"
      :src="logo"
    />
    <app-name :compact="compact" />
    <span :class="getClass">{{ `v${version}` }}</span>
  </div>
</template>

<script>
import pkg from "@/../package.json";
import AppName from "@/components/AppName";

export default {
  name: "AppLogo",
  components: { AppName },
  props: {
    dark: { default: false, type: Boolean },
    compact: { default: false, type: Boolean }
  },
  data() {
    return {
      version: pkg.version,
      logo: process.env.APP_CUSTOMER.upperLeftLogo
    };
  },
  computed: {
    getClass() {
      const base = this.dark ? "white--text" : "";
      return this.compact ? `${base} version--compact` : `text-caption ${base}`;
    }
  }
};
</script>

<style scoped>
.version--compact {
  font-size: 0.5rem;
}
</style>
